import moment from "moment";
import { DATE_FORMAT, TIME_FORMAT } from "utils/constants";

const LAST_WEEK_DAYS_OFFSET = 6;
const MAX_SUMMARY_LENGTH = 80;
export const DOCUMENTATION_URL = "https://support.flashtalking.com/hc/en-us/articles/46739078052371-Bulk-Sheet-Overview";

export function formatRelativeTime(dateValue) {
	const date = moment(dateValue);
	const now = moment();
	const formattedTime = date.format(TIME_FORMAT);

	if (date.isSame(now, 'day')) {
		return `Today at ${formattedTime}`;
	}

	if (date.isSame(moment().subtract(1, 'day'), 'day')) {
		return `Yesterday at ${formattedTime}`;
	}

	const daysAgo = now.diff(date, 'days');
	if (daysAgo <= LAST_WEEK_DAYS_OFFSET) {
		return `Last ${date.format('dddd')} at ${formattedTime}`;
	}

	return date.format(DATE_FORMAT);
}

export function getErrorSummary(errors) {
	const totalErrors = errors.length;
	const errorWord = totalErrors === 1 ? "error" : "errors";
	const prefix = `${totalErrors} ${errorWord} found:`;

	if (totalErrors === 1) {
		const [{ code, message }] = errors;
		const fullSummary = `${code}: ${message}`;
		if (fullSummary.length > MAX_SUMMARY_LENGTH) {
			return { prefix, codesSummary: `${fullSummary.substring(0, MAX_SUMMARY_LENGTH)}...` };
		}
		return { prefix, codesSummary: fullSummary };
	}

	const codeCount = errors.reduce((counts, err) => {
		counts[err.code] ??= 0;
		counts[err.code] += 1;
		return counts;
	}, {});

	const summaryParts = Object.entries(codeCount)
		.map(([code, count]) => `${code}: ${count}`);

	let codesSummary = summaryParts.join(", ");

	if (codesSummary.length > MAX_SUMMARY_LENGTH) {
		const lastCommaIndex = codesSummary.lastIndexOf(",", MAX_SUMMARY_LENGTH);
		if (lastCommaIndex !== -1) {
			codesSummary = `${codesSummary.substring(0, lastCommaIndex)}...`;
		}
	}

	return { prefix, codesSummary };
}

export function groupErrorsByCode(errors) {
	return errors.reduce((grouped, err) => {
		grouped[err.code] ??= [];
		grouped[err.code].push(err.message);
		return grouped;
	}, {});
}

const POSITION_REGEX = /position\s+(\d+)$/i;
const POSITIONS_PLACEHOLDER = "position {POSITIONS}";

export function groupMessagesByPosition(messages) {
	const messageMap = messages.reduce((map, message) => {
		const match = message.match(POSITION_REGEX);
		if (match) {
			const [, position] = match;
			const baseMessage = message.replace(POSITION_REGEX, POSITIONS_PLACEHOLDER);
			map[baseMessage] ??= [];
			map[baseMessage].push(position);
		} else {
			map[message] = null;
		}
		return map;
	}, {});

	return Object.entries(messageMap).map(([message, positions]) => {
		if (positions && positions.length > 0) {
			const positionsText = positions.join(", ");
			return message.replace(POSITIONS_PLACEHOLDER, `position ${positionsText}`);
		}
		return message;
	});
}
